import { useTranslation } from "react-i18next";

import { ILead, LeadRoutingOutcome, isDuplicateRouting } from "../../models/Lead";

/**
 * Compact lead-table marker for a lead the widget created against a vehicle another booking
 * already held. SAV only: the caller gates it, and the API blanks the fields for anyone else.
 * The full explanation is on the lead page - see DuplicateVehicleBanner.
 */
export default function DuplicateVehicleBadge({ lead }: { lead: ILead }) {
  const { t } = useTranslation("leads");

  if (!isDuplicateRouting(lead.routingOutcome)) return null;

  const diverted = lead.routingOutcome === LeadRoutingOutcome.DivertedDuplicateVrm;

  return (
    <span
      title={lead.routingReason ?? t("Another booking already holds this vehicle.")}
      className="inline-flex w-fit items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-800 ring-1 ring-amber-300"
    >
      <span aria-hidden="true">⚑</span>
      {diverted ? t("Dup · SAV") : t("Dup")}
    </span>
  );
}
